// extracted by mini-css-extract-plugin
module.exports = {"Container":"notification_Container__3XxAZ","show":"notification_show__111I6","hide":"notification_hide__22fVG","Metadata":"notification_Metadata__3PdFU"};